import {createListCollection, Field, Portal, Select} from "@chakra-ui/react";

const PRODUCT_LINE_COLLECTION = createListCollection({
    items: [
        {value: "Recruiter", label: "Recruiter"},
        {value: "SalesManager", label: "Sales Manager"},
    ],
});

// Backend requires Agent.Type / Scenario.Type ("Recruiter" | "SalesManager") on every create/edit
// to prevent pairing a Recruiter agent with a SalesManager scenario (or vice versa) -- existing
// rows may still have it null, but new/edited ones must always set it.
const ProductLineTypeSelect = ({value, onChange, label = "Type", required = true, size, placeholder = "Select type"}) => (
    <Field.Root required={required}>
        {label && (
            <Field.Label color={'white'} fontSize={18}>
                {label} {required && <Field.RequiredIndicator/>}
            </Field.Label>
        )}
        <Select.Root
            collection={PRODUCT_LINE_COLLECTION}
            value={value ? [value] : []}
            size={size}
            onValueChange={(e) => onChange(e.value[0] ?? null)}
        >
            <Select.HiddenSelect/>
            <Select.Control>
                <Select.Trigger>
                    <Select.ValueText placeholder={placeholder}/>
                </Select.Trigger>
                <Select.IndicatorGroup>
                    <Select.Indicator/>
                </Select.IndicatorGroup>
            </Select.Control>
            <Portal>
                {/* This control gets used inside Dialog/Popover hosts (z-index 1400/1500 in this design
                    system) as well as standalone. The positioner's --z-index CSS var is set imperatively
                    by Zag's own positioning effect (fixed at 1000), so a plain `zIndex` style prop gets
                    silently overwritten -- only a stylesheet rule with !important beats that inline value. */}
                <Select.Positioner css={{"--z-index": "1600 !important"}}>
                    <Select.Content>
                        {PRODUCT_LINE_COLLECTION.items.map((item) => (
                            <Select.Item item={item} key={item.value}>
                                {item.label}
                                <Select.ItemIndicator/>
                            </Select.Item>
                        ))}
                    </Select.Content>
                </Select.Positioner>
            </Portal>
        </Select.Root>
    </Field.Root>
);

export default ProductLineTypeSelect;
